import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, Lock, ShieldCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ChangePassword() {
    const { user, refresh } = useAuth();
    const nav = useNavigate();
    const [p1, setP1] = useState("");
    const [p2, setP2] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (p1.length < 4) { toast.error("Minimo 4 caratteri"); return; }
        if (p1 !== p2) { toast.error("Le due password non coincidono"); return; }
        setBusy(true);
        try {
            await api.post("/auth/change-password", { new_password: p1 });
            await refresh();
            toast.success("Password aggiornata");
            nav("/");
        } catch (e) { toast.error(formatApiError(e)); }
        finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 relative z-10">
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 text-red-300 text-[10px] font-mono tracking-[0.3em] mb-4">
                        <ShieldCheck size={12} /> CAMBIO PASSWORD OBBLIGATORIO
                    </div>
                    <h1 className="font-display text-3xl md:text-4xl font-extrabold text-slate-50">Imposta una nuova password</h1>
                    <p className="mt-2 text-sm text-slate-400">
                        Ciao <span className="text-amber-300 font-mono">{user?.codice ? `#${user.codice}` : user?.email}</span> · <span className="text-slate-200">{user?.name}</span>
                    </p>
                    <p className="mt-1 text-xs text-slate-500">La password temporanea non è più valida dopo questo cambio.</p>
                </div>

                <Card className="card p-6 md:p-8 bg-transparent">
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <Label className="text-xs text-slate-400 mb-1.5 block">Nuova password</Label>
                            <div className="relative">
                                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                                <Input data-testid="input-newpwd-1" type="password" value={p1}
                                       onChange={(e)=>setP1(e.target.value)} required autoFocus minLength={4}
                                       className="pl-9 bg-slate-950/50 border-slate-800 h-11" />
                            </div>
                        </div>
                        <div>
                            <Label className="text-xs text-slate-400 mb-1.5 block">Conferma nuova password</Label>
                            <div className="relative">
                                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                                <Input data-testid="input-newpwd-2" type="password" value={p2}
                                       onChange={(e)=>setP2(e.target.value)} required minLength={4}
                                       className="pl-9 bg-slate-950/50 border-slate-800 h-11" />
                            </div>
                        </div>
                        <Button data-testid="button-submit-change-pwd" type="submit" disabled={busy}
                                className="w-full h-11 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold gap-2">
                            <KeyRound size={16} /> {busy ? "Attendere…" : "Salva e continua"}
                        </Button>
                    </form>
                </Card>
            </div>
        </div>
    );
}
